function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 18.0565,
  cy: 18.4917,
  r: 15,
  transform: "rotate(-12.199 18.0565 18.4917)",
  fill: "#403D3A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.3656 15.713C23.2563 14.0134 21.8106 13.3994 19.9691 13.1793L20.043 10.8284L18.6128 10.7841L18.5403 13.073C18.1644 13.0605 17.7804 13.0564 17.3971 13.0521L17.4705 10.7483L16.0401 10.7032L15.966 13.0532C15.6561 13.0495 15.3512 13.0464 15.0548 13.0365L15.0548 13.029L13.0813 12.9665L13.0335 14.4945C13.0335 14.4945 14.0911 14.5076 14.073 14.5263C14.6525 14.5449 14.8301 14.8872 14.8761 15.1798L14.7923 17.8575C14.832 17.8587 14.8838 17.8624 14.9434 17.8717L14.792 17.8674L14.674 21.6188C14.6424 21.8 14.5262 22.0874 14.1208 22.0755C14.1392 22.0921 13.0811 22.0429 13.0811 22.0429L12.7431 23.7422L14.6056 23.8008C14.9517 23.8123 15.2924 23.8291 15.6264 23.8415L15.5525 26.2187L16.982 26.2632L17.0558 23.9123C17.4481 23.9319 17.8279 23.9468 18.1987 23.9587L18.1244 26.2998L19.5547 26.3441L19.6296 23.9717C22.0398 23.9094 23.7421 23.3564 24.0222 21.104C24.2484 19.2908 23.4183 18.4516 22.0631 18.0811C22.9065 17.6851 23.448 16.9572 23.3656 15.713ZM21.2035 20.7334C21.1495 22.5102 18.113 22.2122 17.1431 22.1826L17.2431 19.0327C18.2134 19.0639 21.2626 18.8807 21.2035 20.7334ZM20.6781 16.2685C20.6272 17.8851 18.0961 17.616 17.289 17.5907L17.3786 14.7349C18.1857 14.7602 20.7312 14.5823 20.6781 16.2685Z",
  fill: "#DB953C"
});

var SvgBit = function SvgBit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bit.f8a42458.svg";
export { ForwardRef as ReactComponent };